import styled from "styled-components";
import {
  ContentBodyWrapper,
  ContentHeaderWrapper,
  ContentWrapper,
  PopupContainer,
} from "../../../styles/popup";

export const ReservationCreatePopupContainer = styled(PopupContainer)``;
export const ReservationCreatePopupContentWrapper = styled(ContentWrapper)`
  width: 1531px;
  height: 850px;
`;
export const ReservationCreatePopupContentHeaderWrapper = styled(
  ContentHeaderWrapper,
)``;
export const ReservationCreatePopupContentBodyWrapper = styled(
  ContentBodyWrapper,
)`
  gap: 100px;
  margin-bottom: 33.72px;
`;
export const ImageDropWrapper = styled.div`
  width: 536px;
  height: 715px;
  top: 192px;
  left: 390px;
  gap: 0px;
  border-radius: 15px;
  border: 5px dashed #bebebe;
  box-sizing: border-box;
  background: #f0f3f8;
`;
export const ImageDropInitialContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    margin: 0px;
  }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 701px;
  height: 632px;
  gap: 20px;
`;

export const DataRowWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #d9d9d9;
`;

export const InputDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 761px;
  height: 716px;
  justify-content: space-between;
`;

export const DataRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  > input {
    width: 20px;
    height: 20px;
    margin: 0;
  }
`;

export const ReservationCreateActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const Label = styled.label`
  font-family: Pretendard;
  font-size: 20.23px;
  font-weight: 600;
  line-height: 24.15px;
  text-align: left;
  min-width: 170px;
`;

export const Value = styled.label`
  display: flex;
  padding: 8px;
  height: 28.33px;
  box-sizing: border-box;
  align-items: center;
  font-family: Pretendard;
  font-size: 10.79px;
  font-weight: 500;
  text-align: left;
  border: 0.67px solid var(--Black-200, rgba(183, 183, 183, 1));
  flex: 3;
  background: var(--Black-100, #f0f0f0);
  color: #808080;
`;

export const TournamentListWrapper = styled.div`
  background-color: white;
  width: 662px;
  padding: 40px;
  display: flex;
  flex-direction: column;
`;
